<template>
  <div class="inner-content">
    <div
      class="submitted-content--bold mt-10"
      v-html="
        $t(
          'OrderInfo_information_on_next_steps' + ORDER_INFO_PAGE_SUFFIXES.us_form
        )
      "
    />
    <div
      v-html="
        $t(
          'OrderInfo_send_samples_to_address' + ORDER_INFO_PAGE_SUFFIXES.us_form
        )
      "
    />
    <div
      v-html="
        $t(
          'OrderInfo_address' + ORDER_INFO_PAGE_SUFFIXES.us_form
        )
      "
    />
    <div
      class="mt-10"
      v-html="
        $t(
          'OrderInfo_download_consent' + ORDER_INFO_PAGE_SUFFIXES.us_form
        )
      "
    />
    <div>
      <OrderConsentDownload
        :translation-key-suffix="ORDER_INFO_PAGE_SUFFIXES.us_form"
      />
    </div>
    <div
      class="submitted-content--bold mt-10"
      v-html="
        $t('OrderInfo_information_on_the_further_process' + ORDER_INFO_PAGE_SUFFIXES.us_form)
      "
    />
    <div
      v-html="
        $t(
          'OrderInfo_once_we_have_received_your_complete_order' + ORDER_INFO_PAGE_SUFFIXES.us_form
        )
      "
    />
    <div
      v-html="
        $t(
          'OrderInfo_you_will_receive_a_notification' + ORDER_INFO_PAGE_SUFFIXES.us_form
        )
      "
    />
    <div
      class="submitted-content--bold mt-10"
      v-html="
        $t('OrderInfo_need_help' + ORDER_INFO_PAGE_SUFFIXES.us_form)
      "
    />
    <div
      v-html="
        $t(
          'OrderInfo_in_case_of_any_questions' + ORDER_INFO_PAGE_SUFFIXES.us_form
        )
      "
    />
  </div>
</template>

<script setup lang="ts">
import {ORDER_INFO_PAGE_SUFFIXES} from '@/utils/constants'
import OrderConsentDownload from "@/components/orders/OrderConsentDownload.vue";

defineOptions({name: "OrderSubmittedUsForm"});

</script>
